import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70d02b11"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "content-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "article-title" }, "Parabillard", -1))
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "sidebar-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftSideBar = _resolveComponent("LeftSideBar")!
  const _component_front_sidebar = _resolveComponent("front-sidebar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LeftSideBar),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        innerHTML: _ctx.getData()?.indlaeg_versionerings_id?.[0]?.indlaeg_versionering_indhold
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_front_sidebar)
    ])
  ]))
}